/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const setTokenLocalStorage = (value, name) => {
    if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(name, value);
    }
};

const removeNullFromIdentifiers = (identifiers) => identifiers.filter((identifier) => identifier?.value?.length > 0);
const getEmailMarketingId = (payload) => {
    let mi_u = {};
    if (payload?.params) {
        ({ mi_u } = payload.params);
    } else if (payload?.mi_u) {
        ({ mi_u } = payload);
    }
    /*  Fail safe ==> if mi_u is passed twice to the params
        it is returned as array by QueryString
        This makes sure that only first occurence of mi_u is picked */
    return (typeof mi_u === 'string' ? mi_u : mi_u?.[0]) || '';
};

export {
    setTokenLocalStorage,
    removeNullFromIdentifiers,
    getEmailMarketingId,
};

export default {};
